export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrlApi = `${process.env.REACT_APP_BASE_URL}/api/`;
export const baseUrlMedia = process.env.REACT_APP_BASE_URL;

// // api doc => https://militarymoves-admin.dedicateddevelopers.us/apidoc

// export const mediaUrl = (url) => {
//   return `${baseUrlMedia}/uploads/${url}`;
// };

// export const endpoints = {
//   auth: {
//     signup: "user/existence",
//     signUpProfile: "user/signup",
//     login: "api-login",
//     profileDetails: "user/profile/get",
//     profileUpdate: "user/profile/update",
//   },
//   cms: {
//     about: "aboutpolicy/details",
//     faq: "faq/all",
//   },
// };

// export const sucessNotificationEndPoints = [
//   // endpoints.auth.signup,
//   endpoints.auth.signUpProfile,
//   endpoints.auth.login,
//   endpoints.auth.profileUpdate,
// ];

export const mediaUrl = (url) => {
  return `${baseUrlMedia}/uploads/${url}`;
};
export const endpoints = {
  auth: {
    login: "api-login",
    signup: "user/signup",
    profileUpdate: "user/profile/update",
    userdeatils: "/admin/users",

    forgotPassword: "/send-reset-code",
    otpverify: "/check-otp",
    resetpassword: "/reset-password",
    userUpdate: "/admin/updateuser",
    HubuserList: "/admin/users",
    HubuserListStatusUpdate: "/admin/user-status-update",
  },

  Editor: {
    create: "/admin/createuser",
    editorList: "admin/users/4",
  },

  cms: {
    about: "aboutpolicy/details",
    submissions: "admin/submissions",
    Copywriterssubmissions: "copywrite/submissions",
    // submissions: "quality/submissions",
    getUser: "admin/users",
    expensesBreakdown: "admin/expense-breakdown",
    roleWiseExpense: "admin/role-expense-breakdown",
  },
  copywriters: {
    writerList: "admin/users/5",
  },

  QC: {
    QCList: "admin/users/6",
    create: "/admin/createuser",
    videos: "/quality/videos",
    submissions: "/quality/submissions",
    profile: "/user",
    updateprofile: "/updateuser",
  },
  manager: {
    managerList: "admin/users/7",
    createManager: "admin/createuser",
    managerSummary: "admin/users-summary/7",
    managerAssign: "admin/users-by-role",
    managerCardProfile: "admin/user",
    managerAssignUnassignList: "admin/manager-assign-unassign-list",
  },
  partner: {
    partnerList: "admin/users/8",
  },
  acquisitor: {
    acquisitorList: "users-by-role",
  },
  users: {
    byRole: "users-by-role",
  },
  notification: {
    notificationList: "notifications/10",
  },
  video: {
    video: "admin/video",
    get: { admin: "admin/video", qc: "quality/video" },
    update: "admin/update-video",
    duplicate: "admin/update-duplicate",
    release: "admin/release-video",
  },
  videos: {
    videos: "admin/videos",
  },
  expense: {
    expense: "admin/expense-breakdown",
  },
  note: {
    create: "create-note",
    get: "notes?video_id=",
    delete: "notes",
  },
  link: {
    create: "admin/link/create",
  },
  buyer: {
    buyerList: "admin/users/9",
  },
  company: {
    companiesList: "admin/companies",
  },
  copyWritersDashboard: {
    videolist: "copywrite/videos",
    updateUser: "updateuser",
    chnagePassword: "user/change-password",
    submissionsCopyWriters: "copywrite/submissions",
    feedback: "feedback",
  },
  editorDashboard: {
    videoList: "editor/videos",
    editorSubmission: "editor/submissions",
    updateUser: "updateuser",
    chnagePassword: "user/change-password",
    videoDetails: "editor/video",
  },
};

export const sucessNotificationEndPoints = [
  // endpoints.auth.login,
  endpoints.auth.userUpdate,
  endpoints.Editor.create,
  endpoints.auth.forgotPassword,
  endpoints.auth.otpverify,
  endpoints.auth.resetpassword,
];
